// Compteurs fictifs "live" par outil dialectique.
// Trois métriques par outil : débats/duels menés, explorateurs, sessions ce mois-ci.
// Les valeurs ne font que croître et sont persistées (localStorage) pour rester
// cohérentes d'une visite à l'autre, avec un léger effet temps réel.

const SEEDS = {
  deuxVoies: { debats: 2847, explorateurs: 1204, mois: 312 },
  doute: { debats: 1932, explorateurs: 876, mois: 248 },
  proces: { debats: 3561, explorateurs: 1489, mois: 407 },
};

const STORAGE = "coccon_tool_stats_v1";
const state = {};
const subs = {};
let timer = null;
let started = false;

function loadState() {
  let saved = {};
  try {
    saved = JSON.parse(localStorage.getItem(STORAGE) || "{}");
  } catch {
    saved = {};
  }
  Object.keys(SEEDS).forEach((key) => {
    if (saved[key] && typeof saved[key].debats === "number") {
      state[key] = { ...saved[key] };
    } else {
      const s = SEEDS[key];
      // Petit décalage initial pour éviter des nombres identiques partout.
      state[key] = {
        debats: s.debats + Math.floor(Math.random() * 120),
        explorateurs: s.explorateurs + Math.floor(Math.random() * 60),
        mois: s.mois + Math.floor(Math.random() * 25),
      };
    }
  });
  persist();
}

function persist() {
  try {
    localStorage.setItem(STORAGE, JSON.stringify(state));
  } catch {
    /* noop */
  }
}

function tick() {
  // À chaque battement, on fait monter un outil au hasard sur une métrique au hasard.
  const keys = Object.keys(SEEDS);
  const key = keys[Math.floor(Math.random() * keys.length)];
  const metrics = ["debats", "explorateurs", "mois"];
  const metric = metrics[Math.floor(Math.random() * metrics.length)];
  const bump = metric === "debats" ? 1 + Math.floor(Math.random() * 2) : 1;
  state[key][metric] += bump;
  persist();
  (subs[key] || []).forEach((cb) => {
    try {
      cb({ ...state[key] });
    } catch {
      /* noop */
    }
  });
  timer = setTimeout(tick, 3500 + Math.random() * 3500);
}

export function getToolStats(key) {
  if (!state[key]) loadState();
  return { ...state[key] };
}

// Incrémente le compteur d'un outil quand un débat est réellement lancé (+1 débat,
// +1 ce mois-ci). Persiste et notifie les abonnés pour un effet vivant immédiat.
export function bumpToolStat(key) {
  if (!state[key]) loadState();
  if (!state[key]) return;
  state[key].debats += 1;
  state[key].mois += 1;
  persist();
  (subs[key] || []).forEach((cb) => {
    try {
      cb({ ...state[key] });
    } catch {
      /* noop */
    }
  });
}

export function subscribeToolStats(key, cb) {
  if (!Object.keys(state).length) loadState();
  if (!subs[key]) subs[key] = new Set();
  subs[key].add(cb);
  cb({ ...state[key] });
  if (!started) {
    started = true;
    timer = setTimeout(tick, 3000 + Math.random() * 2500);
  }
  return () => {
    subs[key]?.delete(cb);
  };
}
